export default "__VITE_ASSET__B8d2tHW1__"